import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  adminGetConfig,
  adminUpdateConfig,
} from "../../../store/config-action";
import { IconEdit, IconTrash } from "../../Ui/Icon";

const GeneralSetting = () => {
  const DEFAULT_PLACEHOLDER =
    "Enter sentence prayers, thoughts or topics here for Personalized Spiritual guidance.";
  const [loading, setLoading] = useState(false);

  const [userInput, setUserInput] = useState();
  const [existPwd, setExistPwd] = useState(true);
  const [refesh, setRefresh] = useState(Date.now());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
  };

  useEffect(() => {
    const callAPI = async () => {
      setLoading(true);
      try {
        const response = await adminGetConfig();
        setTimeout(() => {
          setLoading(false);
        }, 500);
        if (response.data) {
          setUserInput(response.data.data);
          setExistPwd(response.data.data?.isSetPwd);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  }, [refesh]);

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const callAPI = async () => {
      setLoading(true);
      try {
        await adminUpdateConfig(userInput);
        setTimeout(() => {
          setLoading(false);
        }, 500);

        toast.success("Successfully");
        setRefresh(Date.now());
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  return (
    <form
      onSubmit={onSubmitHandler}
      className="p-4 col-span-6 md:col-span-4  [&_input]:outline-none"
    >
      <div className="mx-auto grid grid-cols-2 gap-x-8 gap-y-10">
        <div className="col-span-1">
          <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Buy more price
          </label>
          <div className="mt-2">
            <input
              id="buyMore.amount"
              name="buyMore.amount"
              type="number"
              defaultValue={userInput?.buyMore?.amount}
              onChange={(e) =>
                setUserInput((preValue) => ({
                  ...preValue,
                  buyMore: {
                    ...preValue.buyMore,
                    amount: parseFloat(e.target.value),
                  },
                }))
              }
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-1">
          <label
            htmlFor="currentPassword"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Buy more request limit
          </label>
          <div className="mt-2">
            <input
              disabled={loading}
              type="number"
              name="buyMore.requestCount"
              id="buyMore.requestCount"
              defaultValue={userInput?.buyMore?.requestCount}
              onChange={(e) =>
                setUserInput((preValue) => ({
                  ...preValue,
                  buyMore: {
                    ...preValue.buyMore,
                    requestCount: parseFloat(e.target.value),
                  },
                }))
              }
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-2">
          <label
            htmlFor="freeLimitRate"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Free chat limit request
          </label>
          <div className="mt-2">
            <input
              disabled={loading}
              type="number"
              name="freeLimitRate"
              id="freeLimitRate"
              defaultValue={userInput?.freeLimitRate}
              onChange={handleChange}
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-2">
          <hr />
        </div>
        <div className="col-span-1">
          <label
            htmlFor="buyMoreVoice.amount"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Buy more voice price
          </label>
          <div className="mt-2">
            <input
              id="buyMoreVoice.amount"
              name="buyMoreVoice.amount"
              type="number"
              defaultValue={userInput?.buyMoreVoice?.amount}
              onChange={(e) =>
                setUserInput((preValue) => ({
                  ...preValue,
                  buyMoreVoice: {
                    ...preValue.buyMoreVoice,
                    amount: parseFloat(e.target.value),
                  },
                }))
              }
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-1">
          <label
            htmlFor="buyMoreVoice.requestCount"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Buy more voice limit
          </label>
          <div className="mt-2">
            <input
              disabled={loading}
              type="number"
              name="buyMoreVoice.requestCount"
              id="buyMoreVoice.requestCount"
              defaultValue={userInput?.buyMoreVoice?.requestCount}
              onChange={(e) =>
                setUserInput((preValue) => ({
                  ...preValue,
                  buyMoreVoice: {
                    ...preValue.buyMoreVoice,
                    requestCount: parseFloat(e.target.value),
                  },
                }))
              }
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-2">
          <label
            htmlFor="landingDescription"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Landing page short description
          </label>
          <div className="mt-2">
            <textarea
              disabled={loading}
              name="landingDescription"
              id="landingDescription"
              value={userInput?.landingDescription || ""}
              onChange={handleChange}
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-2">
          <label
            htmlFor="landingPlaceHolder"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Landing page placeholder
          </label>
          <div className="mt-2">
            <textarea
              disabled={loading}
              name="landingPlaceHolder"
              id="landingPlaceHolder"
              value={userInput?.landingPlaceHolder || ""}
              placeholder={DEFAULT_PLACEHOLDER}
              onChange={handleChange}
              className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="col-span-2">
          <label
            htmlFor="highLevelPassword"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            High Level Password (The password only visible one time when input):
          </label>

          {!existPwd ? (
            <div className="mt-2">
              <input
                type="text"
                disabled={loading}
                name="highLevelPassword"
                id="highLevelPassword"
                onChange={handleChange}
                className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          ) : (
            <span className="flex items-center p-3 gap-3" title="Click to edit">
              <span
                onClick={() => {
                  setExistPwd(false);
                }}
                title="Update Password"
                className="cursor-pointer hover:underline "
              >
                <IconEdit className="size-5 mr-1 text-green-400" /> Update
              </span>
              <span
                title="Remove Password"
                className="cursor-pointer hover:underline "
              >
                <IconTrash
                  onClick={() => {
                    window.confirm(
                      "Click the save button to complete this operation."
                    );
                    setUserInput((pre) => ({
                      ...pre,
                      removePwd: true,
                    }));
                  }}
                  className="size-5 mr-1 text-red-400"
                />
                Remove
              </span>
            </span>
          )}
        </div>
      </div>

      <div className="mt-6 flex items-center justify-start gap-x-6">
        <button
          disabled={loading}
          type="submit"
          className="disabled:opacity-25 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default GeneralSetting;
